import groq from 'groq';

const formFieldProjection = `
  _type,
  _key,
  type,
  label,
  name,
  description,
  required,
  options,
  fileFormats,
  minFiles,
  maxFiles
`;

export const getFormQuery = (slug: string) => groq`
  *[_type == "form" && slug.current == "${slug}" && defined(omnium.projectTypeId)][0]{
    _id,
    _type,
    title,
    description,
    "slug": slug.current,
    omnium,
    body,
    fields[]{
      ${formFieldProjection},
      _type == "formFieldGroup" => {
        columns,
        title,
        fields[]{ ${formFieldProjection} }
      }
    }
  }
`;
